import { Easing } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';
import AnimationClip from '../AnimationClip';
import { delay } from '../../../Utility/Task/TaskQueue';

export class PlayerIconLevelComplete extends AnimationClip {
    public *execute(
        playerIconContainer: GameObject,
        meta: {
            currentNode: GameObject;
            previousNode: GameObject;
        }
    ): IterableIterator<number> {
        const playerIcon = playerIconContainer.find('iconContainer');

        const iconTransform: TransformComponent = playerIcon.getComponent(
            TransformComponent
        );

        const prevNodeTransform = meta.previousNode.getComponent(
            TransformComponent
        );

        const currNodeTransform = meta.currentNode.getComponent(
            TransformComponent
        );

        // Set initial icon position at previous node.
        playerIconContainer
            .getComponent(TransformComponent)
            .position.set(
                prevNodeTransform.position.x,
                prevNodeTransform.position.y
            );

        iconTransform.scale.set(1, 1);

        // Initial delay.
        yield* delay(200);

        const jumpHeight = -75;
        const jumpDuration = 600;

        const jumpAnticipationScaleTween = this.getTween(iconTransform.scale);
        jumpAnticipationScaleTween
            .to({ x: 0.75, y: 0.75 }, jumpDuration * 0.25)
            .easing(Easing.Back.InOut);

        yield* this.startTween(jumpAnticipationScaleTween);

        // Move icon container linearly to next node.
        const containerPositionTween = this.getTween(
            playerIconContainer.getComponent(TransformComponent).position
        );
        containerPositionTween
            .to(
                {
                    x: currNodeTransform.position.x,
                    y: currNodeTransform.position.y,
                },
                jumpDuration
            )
            .easing(Easing.Linear.None)
            .start(this.elapsedTime);

        // Jump icon within container - straight up and down.
        const jumpYTweenUp = this.getTween(iconTransform.position);
        const jumpYTweenDown = this.getTween(iconTransform.position);
        jumpYTweenUp.chain(jumpYTweenDown);

        jumpYTweenUp
            .to({ y: jumpHeight }, jumpDuration * 0.5)
            .easing(Easing.Cubic.Out);
        jumpYTweenDown.to({ y: 0 }, jumpDuration * 0.5).easing(Easing.Cubic.In);
        jumpYTweenUp.start(this.elapsedTime);

        const jumpFollowThroughScaleTween = this.getTween(iconTransform.scale);
        jumpFollowThroughScaleTween
            .to({ x: 1, y: 1 }, jumpDuration * 0.25)
            .easing(Easing.Back.Out)
            .start(this.elapsedTime);

        // Wait for jump.
        yield* delay(jumpDuration);

        const bounceInTween = this.getTween(iconTransform.scale);
        bounceInTween
            .to({ x: 0.9, y: 0.8 }, jumpDuration * 0.25)
            .easing(Easing.Cubic.Out);

        yield* this.startTween(bounceInTween);

        const bounceOutTween = this.getTween(iconTransform.scale);
        bounceOutTween
            .to({ x: 1, y: 1 }, jumpDuration * 0.25)
            .easing(Easing.Cubic.InOut);

        yield* this.startTween(bounceOutTween);
    }
}
